import { Injectable } from '@angular/core';
import { IFlagFeature } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';

@Injectable()
export class UnloadTypeAndApplicationCataloguesHomologationFeature implements IFlagFeature {
  name = Features.UNLOAD_TYPE_AND_APPLICATION_CATALOGUES_HOMOLOGATION;

  public isEnabled(container: any): boolean {
    return container[this.name].isEnabled();
  }
}
